// @ts-nocheck
import mbw from './mbw.png';
import mb from './mb.png';
import creditCard from './ccc.png';
import directDebit from './cc.png';
import cofidis from './cofidis.png';
import paysafecard from './paysafecard.png';
import paysafecash from './paysafecash.png';
import santander from './santander.png';
import googlePay from './googlepay.svg';
import applePay from './applepay.svg';
import euroPix from './europix.svg';

const serviceImages = {
  MBWay: mbw,
  Multibanco: mb,
  CreditCard: creditCard,
  DirectDebit: directDebit,
  Cofidis: cofidis,
  Paysafecard: paysafecard,
  Paysafecash: paysafecash,
  Santander: santander,
  GooglePay: googlePay,
  ApplePay: applePay,
  EuroPix: euroPix,
};

export default serviceImages;
